import React, { Component } from 'react'
import CheckTFA from './checkTFA.jsx'
import ChangeTFA from './changeTFA.jsx'

export default class TFA extends Component {
    constructor(props) {
        super(props)

        this.state = {
            checkTFADisplay: true,
        }
    }

    render() {
        let { checkTFADisplay } = this.state
        if (Object.keys(this.props.currentData) === 0) return null
        return checkTFADisplay === true ? (
            <CheckTFA
                twoFaType={this.props.tfaType}
                switchCheckDisplay={this.switchCheckDisplay}
            />
        ) : (
            <ChangeTFA
                twoFaType={this.props.tfaType}
                tfaAvailableTypes={this.props.currentData['options']}
                switchCheckDisplay={this.switchCheckDisplay}
                switchTFAType={this.props.switchTFAType}
                dataProtection={this.props.dataProtection}
                getStatus={this.props.getStatus}
            />
        )
    }

    switchCheckDisplay = () => {
        this.setState({
            checkTFADisplay: !this.state.checkTFADisplay,
        })
    }
}
